<template>
  <div class="checkout-done">
    <div v-if="loading">
      <div class="text-center py-5">
        <h4>Выполняется проверка платежа, пожалуйста, подождите</h4>
      </div>
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else class="py-5">
      <div v-if="payment_error" class="text-center py-3 text-danger">
        <h4>Ошибка! Ваш платеж был отклонен, пожалуйста, попробуйте еще раз или обратитесь
          в службу поддержки.</h4>
      </div>
      <div v-else class="text-center py-3 text-success">
        <h4>Оплата успешно проведена, средства зачислены на ваш баланс.</h4>
      </div>
      <div class="text-center">
        <router-link to="/dashboard" >Вернутся на главную</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CheckoutDone',
  data() {
    return {
      loading: true,
      payment_error: false,
    };
  },
  computed: {
    ...mapState('payment', ['paymentData', 'paymentId', 'error']),
  },
  methods: {
    ...mapActions('payment', ['resetPayment']),
    checkPayment() {
      this.$store.dispatch('payment/checkPayment', this.paymentId)
        .then(() => {
          if (this.paymentData.is_paid) {
            this.loading = false;
            this.resetPayment();
          } else if (this.paymentData.is_paid === null) {
            setTimeout(this.checkPayment, 3500);
          } else if (!this.paymentData.is_paid) {
            this.resetPayment();
            this.loading = false;
            this.payment_error = true;
          }
        });
    },
  },
  mounted() {
    if (this.paymentId) {
      this.checkPayment();
    } else {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>
